import BaseObject from "@base/baseObject.js";

/**
 * Gallery entity. Mirrors the backend's legacy overview shape (flattened en_/de_
 * content, accessType = visibility, images: [{ path, name }]).
 */
export default class GalleryObject extends BaseObject {
  static fields = [
    { key: "en_title", type: "text", section: "en", editable: true },
    { key: "en_subtitle", type: "text", section: "en", editable: true },
    { key: "en_content", type: "textarea", section: "en", editable: true },
    { key: "de_title", type: "text", section: "de", editable: true },
    { key: "de_subtitle", type: "text", section: "de", editable: true },
    { key: "de_content", type: "textarea", section: "de", editable: true },
    { key: "date", type: "date", section: "meta", editable: true },
    { key: "type", type: "text", section: "meta", editable: true },
    { key: "accessType", type: "visibility", section: "meta", editable: true },
    { key: "mapId", type: "text", section: "map", editable: true },
    { key: "zoomLevel", type: "number", section: "map", editable: true },
    { key: "titleImage", type: "text", section: "meta", editable: false },
  ];

  title(lang) {
    return this[`${lang}_title`] || this.en_title || this.de_title || "";
  }

  subtitle(lang) {
    return this[`${lang}_subtitle`] || "";
  }

  content(lang) {
    return this[`${lang}_content`] || "";
  }

  isPublic() {
    return this.accessType === 1;
  }

  isDraft() {
    return this.accessType === 2;
  }

  /** Gallery tags (always an array). */
  tagList() {
    return Array.isArray(this.tags) ? this.tags : [];
  }

  coverImage() {
    return this.titleImage || this.images?.[0]?.name || null;
  }

  /** Parse the JSON-encoded mapPlaceId into an array of place ids. */
  placeIds() {
    if (Array.isArray(this.mapPlaceId)) return this.mapPlaceId;
    if (typeof this.mapPlaceId === "string" && this.mapPlaceId.trim()) {
      try {
        return JSON.parse(this.mapPlaceId);
      } catch {
        return [];
      }
    }
    return [];
  }
}
